var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can('read', 'payment-link'))?_c('main-content',[_c('manage-ps')],1):_c('main-content',[_c('kt-panel',[_c('kt-panel-body',[(_vm.status !== 'loading')?_c('ps-form',{attrs:{"form_data":_vm.form_data,"submit":_vm.submit}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }